import { render, staticRenderFns } from "./ModalInventaire.vue?vue&type=template&id=70f89bb3&"
import script from "./ModalInventaire.vue?vue&type=script&lang=js&"
export * from "./ModalInventaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports